import { render, staticRenderFns } from "./RegularForms.vue?vue&type=template&id=44d39ede"
import script from "./RegularForms.vue?vue&type=script&lang=js"
export * from "./RegularForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports